import { render, staticRenderFns } from "./UnityScene.vue?vue&type=template&id=0263be86&"
import script from "./UnityScene.vue?vue&type=script&lang=ts&"
export * from "./UnityScene.vue?vue&type=script&lang=ts&"
import style0 from "./UnityScene.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports